import ApiClient from '../../api/src/ApiClient'


export default {
    namespaced: true,

    state: {
        list: [],
        map: {}
    },

    mutations: {
        pageList(state, response) {
            state.list = response;
        },
        pageMap(state, page) {
            let map = {};
            for (var type in state.map) {
                map[type] = state.map[type];
            }
            map[page.pagetype] = page;
            state.map = map;
        }
    },

    actions: {
        async getList({commit, state}) {
            if(state.list.length === 0) {
                commit('pageList', await ApiClient.get('api/cms/pages'));
            }
        },

        async getFullPage({commit, state}, type) {
            if(type) {
                if (!state.map[type]) {
                    commit('pageMap', await ApiClient.get('api/cms/page?type=' + type));
                }
            }
        }
    },
}





// WEBPACK FOOTER //
// ./src/components/cms/src/CmsStore.js